export type FeedbackRating = 'not_helpful' | 'helpful';

/** Matches backend Prisma enum `FeedbackRating` */
export const FeedbackRating = {
  NOT_HELPFUL: 'not_helpful',
  HELPFUL: 'helpful',
} as const satisfies Record<string, FeedbackRating>;
